// Default board color palette - plain and simple, no glow
export const DEFAULT_COLORS = {
  primary: '#706942',
  secondary: '#AAAAAA',
  emissive: '#000000',
  background: '#111111',
  accent: '#555555',
  gridLine: '#333333',
};

// Single color for all blocks
export const DEFAULT_TETROMINO_COLORS = {
  'l-tetromino-active': '#9B59B6',
  'j-tetromino-active': '#9B59B6',
  't-tetromino-active': '#9B59B6',
  'square-tetromino-active': '#9B59B6',
  'line-tetromino-active': '#9B59B6',
  'z-tetromino-active': '#9B59B6',
  's-tetromino-active': '#9B59B6',
};

export const getBlockColor = (colorClass) => {
  return DEFAULT_TETROMINO_COLORS[colorClass] || DEFAULT_COLORS.primary;
};

// No emissive glow on any block
export const getEmissiveColor = () => {
  return '#000000';
};

export const THEME_CONFIG = {
  name: 'Default',
  background: '#111111',
  bloomIntensity: 0,
  bloomThreshold: 1.0,
  vignetteOffset: 0,
  vignetteDarkness: 0,
};
